import React, { useCallback } from 'react';
import { useObservable, useCallbackObservable } from 'react-use-observable';

import { App, Modal, Button } from 'antd';

import { Formik, Form, Field } from 'formik';
import type { FormikProps } from 'formik';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IWhiteList } from 'v2/interfaces/whitelist';
import whitelistService, { InitialWhiteList } from 'v2/services/whitelist';

import CreateAndEditSchema from './validations';

const CreateAndEdit = () => {
  const { message } = App.useApp();
  const [open] = useObservable(() => whitelistService.getCreateAndEditDialog(), []);
  const [currentWhiteList] = useObservable(() => whitelistService.getCurrentWhiteList(), []);
  const [onSubmit] = useCallbackObservable(
    (values: IWhiteList, { setSubmitting, resetForm }: FormikProps<IWhiteList>) => {
      return whitelistService.saveOrUpdate(values).pipe(
        tap(() => {
          setSubmitting(false);
          resetForm({ values });
          whitelistService.setCreateAndEditDialog(false);

          if (values?.id) {
            message.success('Whitelist alterada com sucesso.');
            return;
          }

          message.success('Whitelist criada com sucesso.');
        }),
        catchError(err => {
          const errorMessage = typeof err === 'string' ? err : 'Valide os campos obrigatórios';
          setSubmitting(false);
          message.error(errorMessage);
          return of(true);
        })
      );
    },
    [message]
  );

  const closeDialog = useCallback(() => {
    whitelistService.setCreateAndEditDialog(false);
  }, []);

  return (
    <Modal
      open={open}
      onCancel={closeDialog}
      footer={null}
      title={currentWhiteList?.id ? 'Edite o cliente' : 'Adicione um novo cliente'}
      destroyOnClose
    >
      <Formik
        initialValues={currentWhiteList ?? InitialWhiteList}
        enableReinitialize
        validationSchema={CreateAndEditSchema}
        onSubmit={onSubmit}
      >
        {({ isValid, isSubmitting }) => (
          <Form id='whitelist-form'>
            <div className='grid grid-cols-1 gap-4'>
              <div>
                <Field
                  id={'customer_name'}
                  name={'customer_name'}
                  component={TextFormField}
                  fullWidth
                  label={'Nome'}
                  placeholder={'Insira o nome'}
                />
              </div>
              <div>
                <Field
                  id={'customer_email'}
                  name={'customer_email'}
                  component={TextFormField}
                  fullWidth
                  label={'E-mail'}
                  placeholder={'Insira o e-mail'}
                />
              </div>
              <div>
                <Field
                  id={'customer_document'}
                  name={'customer_document'}
                  component={TextFormField}
                  fullWidth
                  label={'CPF/CNPJ'}
                  placeholder={'Insira o documento'}
                  mask={'document'}
                />
              </div>
            </div>
            <div className='mt-4 flex justify-end gap-2'>
              <Button type='text' onClick={closeDialog}>
                Fechar
              </Button>
              <Button type='primary' htmlType='submit' disabled={!isValid || isSubmitting} loading={isSubmitting}>
                Salvar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CreateAndEdit;
